import { mdiChevronRight } from '@mdi/js';
import { Icon } from '@mdi/react';
import React, { useState } from 'react';
import * as S from './collapsible-container.styles';

export interface ICollapsibleContainerProps {
    title: string;
    defaultOpen?: boolean;
    children: React.ReactNode;
    className?: string;
}

export const CollapsibleContainer: React.FunctionComponent<ICollapsibleContainerProps> = (
    props: ICollapsibleContainerProps
): React.ReactElement => {
    const { title, defaultOpen = false, children, className } = props;
    const [isOpen, setIsOpen] = useState(defaultOpen);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <S.Container className={className}>
            <S.Header onClick={handleToggle}>
                <S.Title>{title}</S.Title>
                <S.ChevronIcon isOpen={isOpen}>
                    <Icon path={mdiChevronRight} size={0.75} />
                </S.ChevronIcon>
            </S.Header>
            <S.Content isOpen={isOpen}>
                {children}
            </S.Content>
        </S.Container>
    );
};

